import { FC } from 'react'
import { AnimatePresence } from 'framer-motion'

import { Question } from './questions'
import { Slider } from './slider'
import {
  Card as CardContainer,
  Description,
  Inner,
  Instructions,
  Label,
  Option,
  Options,
  RadioInput,
  Title,
} from './styled'
import { theme } from 'styles/theme'

type Props = {
  question: Question
  index: number
  onAnswer: (value: string) => void
  selectedValue?: string
}

export const Card: FC<Props> = ({
  question,
  index,
  onAnswer,
  selectedValue,
}) => (
  <CardContainer>
    <Inner layout>
      <AnimatePresence mode="popLayout">
        {(!selectedValue || !('options' in question)) && (
          <Title
            key={`title-${index}`}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {question.title}
          </Title>
        )}
      </AnimatePresence>

      {'options' in question ? (
        <Options layout>
          <AnimatePresence mode="popLayout">
            {question.options.map(
              (option) =>
                (!selectedValue ||
                  option === selectedValue ||
                  option === question.correctAnswer) && (
                  <Option
                    layout
                    key={option}
                    animate={{ opacity: 1 }}
                    exit={{
                      opacity: 0,
                      transition: { type: 'tween', duration: 0.3 },
                    }}
                  >
                    <label>
                      <RadioInput
                        disabled={!!selectedValue}
                        onChange={(evt) => onAnswer(evt.target.value)}
                        name={index.toString()}
                        value={option}
                      />
                      <Label
                        $condensed={question.condensed}
                        $highlighted={
                          !!selectedValue && question.correctAnswer === option
                        }
                      >
                        {option}
                      </Label>
                    </label>
                  </Option>
                )
            )}
          </AnimatePresence>
        </Options>
      ) : (
        <>
          <AnimatePresence mode="popLayout">
            {!selectedValue && (
              <Instructions
                layout
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                key="instructions"
              >
                {question.instructions}
              </Instructions>
            )}
          </AnimatePresence>
          <Slider
            onChange={(value) => onAnswer(value.toString())}
            selectedValue={selectedValue}
          />
        </>
      )}

      {!!selectedValue && !!question.description && (
        <Description
          animate={{
            opacity: 1,
            translateY: '0rem',
            transition: {
              type: 'tween',
              ease: theme.easeValues.out,
              duration: 0.7,
              delay: 0.3,
            },
          }}
          initial={{ opacity: 0, translateY: '2rem' }}
        >
          {question.description}
        </Description>
      )}
    </Inner>
  </CardContainer>
)
